import Vue from "vue";

const templateId = +document.body.getAttribute("data-tplId") || +document.body.getAttribute("tplid");
const templatePath = "./templates/" + templateId + "/options.js";


import Singles from './singles.js';
import Multiselect from './multiselect.js';
import Doubleinput from './doubleinput.js';


let component = Vue.component("options", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props: ['opt','groupid','jsonval'],
      components: {
        appSingleselect: Singles,
        appMultiselect: Multiselect,
        appDoubleinput: Doubleinput
      },
      data() {
        return {
          urlValue: ''
        }
      },
      created() {
        let x = window.location.href
        if (x.indexOf('mode=find') > 0) {
          this.urlValue = x
        }
      }
    });
  });
});
export default component;
